export default __webpack_public_path__ + "static/media/Chicago-Grey.a0eee6c1.jpg";